// WARNING: This file is auto generated by `./scripts/build_blog_posts`.
/* eslint-disable */

import asset_2023_01_12_hello_world from "./2023-01-12_hello_world.md";
import asset_duckypad from "./2023-01-22_mallardscript/duckypad.jpg";
import asset_duckyscript_example from "./2023-01-22_mallardscript/duckyscript_example.gif";
import asset_2023_01_22_mallardscript from "./2023-01-22_mallardscript.md";
import asset_usb_rubber_ducky from "./2023-01-22_mallardscript/usb_rubber_ducky.webp";
import asset_demo from "./2023-02-12_better_react_copy_component/demo.gif";
import asset_2023_02_12_better_react_copy_component from "./2023-02-12_better_react_copy_component.md";
import asset_cortona from "./2024-01-30_bookit/cortona.webp";
import asset_i3_configuration from "./2024-01-30_bookit/i3_configuration.png";
import asset_2024_01_30_bookit from "./2024-01-30_bookit.md";
import asset_search_ui from "./2024-01-30_bookit/search_ui.jpg";
import asset_tabs from "./2024-01-30_bookit/tabs.gif";
import asset_tray from "./2024-01-30_bookit/tray.jpg";
import asset_3d_printed_maze_0 from "./2024-01-30_mazes_mazes_mazes/3d_printed_maze_0.jpg";
import asset_3d_printed_maze_1 from "./2024-01-30_mazes_mazes_mazes/3d_printed_maze_1.jpg";
import asset_2024_01_30_mazes_mazes_mazes from "./2024-01-30_mazes_mazes_mazes.md";
import asset_2024_03_04_react_snake_25 from "./2024-03-04_react-snake-25.md";
import asset_snake from "./2024-03-04_react-snake-25/snake.gif";
import asset_2024_11_08_react_discord_presence from "./2024-11-08_react-discord-presence.md";
import asset_1_GeneralIdea from "./2024-11-19_ceiling_projector/1_GeneralIdea.gif";
import asset_2_CutOut from "./2024-11-19_ceiling_projector/2_CutOut.gif";
import asset_3_CompleteModel from "./2024-11-19_ceiling_projector/3_CompleteModel.gif";
import asset_4_Supports from "./2024-11-19_ceiling_projector/4_Supports.gif";
import asset_5_Printing from "./2024-11-19_ceiling_projector/5_Printing.gif";
import asset_6_CompletePrinted from "./2024-11-19_ceiling_projector/6_CompletePrinted.gif";
import asset_7_CompletePrintedWithProjectorCopy from "./2024-11-19_ceiling_projector/7_CompletePrintedWithProjectorCopy.gif";
import asset_7_CompletePrintedWithProjector from "./2024-11-19_ceiling_projector/7_CompletePrintedWithProjector.gif";
import asset_8_Done from "./2024-11-19_ceiling_projector/8_Done.gif";
import asset_2024_11_19_ceiling_projector from "./2024-11-19_ceiling_projector.md";
import asset_Airport from "./2026-04-24-trip-japan/Airport.jpg";
import asset_Backpack from "./2026-04-24-trip-japan/Backpack.jpg";
import asset_Bonsai from "./2026-04-24-trip-japan/Bonsai.jpg";
import asset_CherryBlossoms from "./2026-04-24-trip-japan/CherryBlossoms.jpg";
import asset_Dotonbori from "./2026-04-24-trip-japan/Dotonbori.jpg";
import asset_FriedChciken from "./2026-04-24-trip-japan/FriedChciken.jpg";
import asset_Gacha from "./2026-04-24-trip-japan/Gacha.jpg";
import asset_Kyoto_NioMon_Gate from "./2026-04-24-trip-japan/Kyoto_NioMon_Gate.jpg";
import asset_Kyoto_Otani_Cemetery_A from "./2026-04-24-trip-japan/Kyoto_Otani_Cemetery_A.jpg";
import asset_Kyoto_Otani_Cemetery_B from "./2026-04-24-trip-japan/Kyoto_Otani_Cemetery_B.jpg";
import asset_Kyoto_Remote_Train from "./2026-04-24-trip-japan/Kyoto_Remote_Train.jpg";
import asset_Kyoto_Senbon_Torii_Profile from "./2026-04-24-trip-japan/Kyoto_Senbon_Torii_Profile.jpg";
import asset_Kyoto_Senbon_Torii_Tori from "./2026-04-24-trip-japan/Kyoto_Senbon_Torii_Tori.jpg";
import asset_Kyoto_Yakiniku from "./2026-04-24-trip-japan/Kyoto_Yakiniku.jpg";
import asset_2026_04_24_trip_japan from "./2026-04-24-trip-japan.md";
import asset_Okinawa_Aquarium_Frog from "./2026-04-24-trip-japan/Okinawa_Aquarium_Frog.jpg";
import asset_Okinawa_Aquarium from "./2026-04-24-trip-japan/Okinawa_Aquarium.jpg";
import asset_Okinawa_Beach from "./2026-04-24-trip-japan/Okinawa_Beach.jpg";
import asset_Okinawa_BusStop from "./2026-04-24-trip-japan/Okinawa_BusStop.jpg";
import asset_Okinawa_CaveCafe from "./2026-04-24-trip-japan/Okinawa_CaveCafe.jpg";
import asset_Okinawa_Megalodon from "./2026-04-24-trip-japan/Okinawa_Megalodon.jpg";
import asset_Okinawa_PeaceMemorial from "./2026-04-24-trip-japan/Okinawa_PeaceMemorial.jpg";
import asset_Okinawa_World from "./2026-04-24-trip-japan/Okinawa_World.jpg";
import asset_Onigiri from "./2026-04-24-trip-japan/Onigiri.jpg";
import asset_OsakaTemple_CherryBlossoms from "./2026-04-24-trip-japan/OsakaTemple_CherryBlossoms.jpg";
import asset_Osaka_Temple from "./2026-04-24-trip-japan/Osaka_Temple.jpg";
import asset_Pokemon from "./2026-04-24-trip-japan/Pokemon.jpg";
import asset_Samurai from "./2026-04-24-trip-japan/Samurai.jpg";
import asset_SandoLabs_SteakSandwich from "./2026-04-24-trip-japan/SandoLabs_SteakSandwich.jpg";
import asset_Sandwich_BLTE from "./2026-04-24-trip-japan/Sandwich_BLTE.jpg";
import asset_Sandwich_Egg from "./2026-04-24-trip-japan/Sandwich_Egg.jpg";
import asset_Sandwich_Strawberry from "./2026-04-24-trip-japan/Sandwich_Strawberry.jpg";
import asset_Sandwich_Teriyaki from "./2026-04-24-trip-japan/Sandwich_Teriyaki.jpg";
import asset_Tokyo_Samurai_Targets from "./2026-04-24-trip-japan/Tokyo_Samurai_Targets.jpg";
import asset_Tokyo_Skyline from "./2026-04-24-trip-japan/Tokyo_Skyline.jpg";
import asset_Tokyo_Train_System from "./2026-04-24-trip-japan/Tokyo_Train_System.jpg";
import asset_feed from "./feed.xml";

export const Assets: { [key: string]: string } = {
  [`./2023-01-12_hello_world.md`]: asset_2023_01_12_hello_world,
  [`./2023-01-22_mallardscript/duckypad.jpg`]: asset_duckypad,
  [`./2023-01-22_mallardscript/duckyscript_example.gif`]: asset_duckyscript_example,
  [`./2023-01-22_mallardscript.md`]: asset_2023_01_22_mallardscript,
  [`./2023-01-22_mallardscript/usb_rubber_ducky.webp`]: asset_usb_rubber_ducky,
  [`./2023-02-12_better_react_copy_component/demo.gif`]: asset_demo,
  [`./2023-02-12_better_react_copy_component.md`]: asset_2023_02_12_better_react_copy_component,
  [`./2024-01-30_bookit/cortona.webp`]: asset_cortona,
  [`./2024-01-30_bookit/i3_configuration.png`]: asset_i3_configuration,
  [`./2024-01-30_bookit.md`]: asset_2024_01_30_bookit,
  [`./2024-01-30_bookit/search_ui.jpg`]: asset_search_ui,
  [`./2024-01-30_bookit/tabs.gif`]: asset_tabs,
  [`./2024-01-30_bookit/tray.jpg`]: asset_tray,
  [`./2024-01-30_mazes_mazes_mazes/3d_printed_maze_0.jpg`]: asset_3d_printed_maze_0,
  [`./2024-01-30_mazes_mazes_mazes/3d_printed_maze_1.jpg`]: asset_3d_printed_maze_1,
  [`./2024-01-30_mazes_mazes_mazes.md`]: asset_2024_01_30_mazes_mazes_mazes,
  [`./2024-03-04_react-snake-25.md`]: asset_2024_03_04_react_snake_25,
  [`./2024-03-04_react-snake-25/snake.gif`]: asset_snake,
  [`./2024-11-08_react-discord-presence.md`]: asset_2024_11_08_react_discord_presence,
  [`./2024-11-19_ceiling_projector/1_GeneralIdea.gif`]: asset_1_GeneralIdea,
  [`./2024-11-19_ceiling_projector/2_CutOut.gif`]: asset_2_CutOut,
  [`./2024-11-19_ceiling_projector/3_CompleteModel.gif`]: asset_3_CompleteModel,
  [`./2024-11-19_ceiling_projector/4_Supports.gif`]: asset_4_Supports,
  [`./2024-11-19_ceiling_projector/5_Printing.gif`]: asset_5_Printing,
  [`./2024-11-19_ceiling_projector/6_CompletePrinted.gif`]: asset_6_CompletePrinted,
  [`./2024-11-19_ceiling_projector/7_CompletePrintedWithProjectorCopy.gif`]: asset_7_CompletePrintedWithProjectorCopy,
  [`./2024-11-19_ceiling_projector/7_CompletePrintedWithProjector.gif`]: asset_7_CompletePrintedWithProjector,
  [`./2024-11-19_ceiling_projector/8_Done.gif`]: asset_8_Done,
  [`./2024-11-19_ceiling_projector.md`]: asset_2024_11_19_ceiling_projector,
  [`./2026-04-24-trip-japan/Airport.jpg`]: asset_Airport,
  [`./2026-04-24-trip-japan/Backpack.jpg`]: asset_Backpack,
  [`./2026-04-24-trip-japan/Bonsai.jpg`]: asset_Bonsai,
  [`./2026-04-24-trip-japan/CherryBlossoms.jpg`]: asset_CherryBlossoms,
  [`./2026-04-24-trip-japan/Dotonbori.jpg`]: asset_Dotonbori,
  [`./2026-04-24-trip-japan/FriedChciken.jpg`]: asset_FriedChciken,
  [`./2026-04-24-trip-japan/Gacha.jpg`]: asset_Gacha,
  [`./2026-04-24-trip-japan/Kyoto_NioMon_Gate.jpg`]: asset_Kyoto_NioMon_Gate,
  [`./2026-04-24-trip-japan/Kyoto_Otani_Cemetery_A.jpg`]: asset_Kyoto_Otani_Cemetery_A,
  [`./2026-04-24-trip-japan/Kyoto_Otani_Cemetery_B.jpg`]: asset_Kyoto_Otani_Cemetery_B,
  [`./2026-04-24-trip-japan/Kyoto_Remote_Train.jpg`]: asset_Kyoto_Remote_Train,
  [`./2026-04-24-trip-japan/Kyoto_Senbon_Torii_Profile.jpg`]: asset_Kyoto_Senbon_Torii_Profile,
  [`./2026-04-24-trip-japan/Kyoto_Senbon_Torii_Tori.jpg`]: asset_Kyoto_Senbon_Torii_Tori,
  [`./2026-04-24-trip-japan/Kyoto_Yakiniku.jpg`]: asset_Kyoto_Yakiniku,
  [`./2026-04-24-trip-japan.md`]: asset_2026_04_24_trip_japan,
  [`./2026-04-24-trip-japan/Okinawa_Aquarium_Frog.jpg`]: asset_Okinawa_Aquarium_Frog,
  [`./2026-04-24-trip-japan/Okinawa_Aquarium.jpg`]: asset_Okinawa_Aquarium,
  [`./2026-04-24-trip-japan/Okinawa_Beach.jpg`]: asset_Okinawa_Beach,
  [`./2026-04-24-trip-japan/Okinawa_BusStop.jpg`]: asset_Okinawa_BusStop,
  [`./2026-04-24-trip-japan/Okinawa_CaveCafe.jpg`]: asset_Okinawa_CaveCafe,
  [`./2026-04-24-trip-japan/Okinawa_Megalodon.jpg`]: asset_Okinawa_Megalodon,
  [`./2026-04-24-trip-japan/Okinawa_PeaceMemorial.jpg`]: asset_Okinawa_PeaceMemorial,
  [`./2026-04-24-trip-japan/Okinawa_World.jpg`]: asset_Okinawa_World,
  [`./2026-04-24-trip-japan/Onigiri.jpg`]: asset_Onigiri,
  [`./2026-04-24-trip-japan/OsakaTemple_CherryBlossoms.jpg`]: asset_OsakaTemple_CherryBlossoms,
  [`./2026-04-24-trip-japan/Osaka_Temple.jpg`]: asset_Osaka_Temple,
  [`./2026-04-24-trip-japan/Pokemon.jpg`]: asset_Pokemon,
  [`./2026-04-24-trip-japan/Samurai.jpg`]: asset_Samurai,
  [`./2026-04-24-trip-japan/SandoLabs_SteakSandwich.jpg`]: asset_SandoLabs_SteakSandwich,
  [`./2026-04-24-trip-japan/Sandwich_BLTE.jpg`]: asset_Sandwich_BLTE,
  [`./2026-04-24-trip-japan/Sandwich_Egg.jpg`]: asset_Sandwich_Egg,
  [`./2026-04-24-trip-japan/Sandwich_Strawberry.jpg`]: asset_Sandwich_Strawberry,
  [`./2026-04-24-trip-japan/Sandwich_Teriyaki.jpg`]: asset_Sandwich_Teriyaki,
  [`./2026-04-24-trip-japan/Tokyo_Samurai_Targets.jpg`]: asset_Tokyo_Samurai_Targets,
  [`./2026-04-24-trip-japan/Tokyo_Skyline.jpg`]: asset_Tokyo_Skyline,
  [`./2026-04-24-trip-japan/Tokyo_Train_System.jpg`]: asset_Tokyo_Train_System,
  [`./feed.xml`]: asset_feed,
};
